import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import Vue from "vue";
import Vuex from "vuex";
import { SnackbarMessageStructure } from "@/shared/models/SnackbarMessageStructure";
import { FormsData } from "@/modules/Forms/models/FormsData";
import { MedicalOrderPreviewEventTimelineModel } from "@/modules/MedicalOrder/models/MedicalOrderPreviewEventTimelineModel";
import { ChatComunication } from "@/modules/Home/components/ChatWindow/Model/ChatComunication.model";
import { Utils } from "@/shared/utils/utils";
import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    onSession: false,
    userId: "",
    role: "",
    userName: "",
    avatar: "",
    panelView: false,
    dataToMainView: {} as MenuDataStructure,
    dataToLateralMenu: {} as MenuDataStructure,
    refreshProfileServices: true,
    taskRefreshing: false,
    notifications: [],
    snackbarMessage: {} as SnackbarMessageStructure,
    profileCrumbs: {} as MenuDataStructure,
    onChangeServiceValidation: false,
    refreshTemplateService: false,
    generalDataTasks: [] as FormsData[],
    dashBoardSearchName: "",
    refreshGroupService: false,
    campusServiceTemplate: false,
    callOrigin: "",
    userState: "",
    medicalOrderValidation: false,
    medicalOrderObjList: {} as MedicalOrderPreviewEventTimelineModel,
    chatComunication: {} as ChatComunication,
    groupsLevels: [],
    medicalOrderStates: [],
    constantsUI: {}
  },
  mutations: {
    changeSession(state, payload) {
      state.onSession = payload;
    },
    setUserId(state, payload) {
      state.userId = payload;
    },
    setPanelView(state, payload) {
      state.panelView = payload;
    },
    setRole(state, payload) {
      state.role = payload;
    },
    setUserName(state, payload) {
      state.userName = payload;
    },
    setAvatar(state, payload) {
      state.avatar = payload;
    },
    setDataToMainView(state, payload) {
      state.dataToMainView = payload;
    },
    setDataToLateralMenu(state, payload) {
      state.dataToLateralMenu = payload;
    },
    setRefreshProfileServices(state) {
      state.refreshProfileServices = !state.refreshProfileServices;
    },
    setTaskRefreshing(state, payload) {
      state.taskRefreshing = payload;
    },
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setSnackbarMessage(state, payload) {
      state.snackbarMessage = payload;
    },
    setProfileCrumbs(state, payload) {
      state.profileCrumbs = payload;
    },
    setOnChangeServiceValidation(state, payload) {
      state.onChangeServiceValidation = payload;
    },
    setRefreshTemplateService(state, payload) {
      state.refreshTemplateService = payload;
    },
    setGeneralDataTasks(state, payload) {
      state.generalDataTasks = payload;
    },
    setDashBoardNameSearch(state, payload) {
      state.dashBoardSearchName = payload;
    },
    setGroupServiceRefresh(state, payload) {
      state.refreshGroupService = payload;
    },
    setCampusServiceTemplate(state, payload) {
      state.campusServiceTemplate = payload;
    },
    setCallOrigin(state, payload) {
      state.callOrigin = payload;
    },
    setUserState(state, payload) {
      state.userState = payload;
    },
    setMedicalOrderValidation(state, payload) {
      state.medicalOrderValidation = payload;
    },
    setMedicalOrderObjList(state, payload) {
      state.medicalOrderObjList = payload;
    },
    setChatComunication(state, payload) {
      state.chatComunication = payload;
    },
    setGroupsLevels(state, payload) {
      state.groupsLevels = payload;
    },
    setOrderStates(state, payload) {
      state.medicalOrderStates = payload;
    },
    setConstantsUI(state, payload) {
      state.constantsUI = payload;
    }
  },
  getters: {
    getDataToMainView: state => state.dataToMainView,
    getDataToLateralMenu: state => state.dataToLateralMenu,
    getRefreshProfileServices: state => state.refreshProfileServices,
    getPanelView: state => state.panelView,
    getTaskRefreshing: state => state.taskRefreshing,
    getNotifications: state => state.notifications,
    getSnackbarMessage: state => state.snackbarMessage,
    getProfileCrumbles: state => state.profileCrumbs,
    getOnChangeServiceValidation: state => state.onChangeServiceValidation,
    getRefreshTemplateService: state => state.refreshTemplateService,
    getGeneralDataTasks: state => state.generalDataTasks,
    getDashBoardNameSearch: state => state.dashBoardSearchName,
    getGroupServiceRefresh: state => state.refreshGroupService,
    getUserRole: state => state.role,
    getCampusServiceTemplate: state => state.campusServiceTemplate,
    getCallOrigin: state => state.callOrigin,
    getUserState: state => state.userState,
    getMedicalOrderValidation: state => state.medicalOrderValidation,
    getMedicalOrderObjList: state => state.medicalOrderObjList,
    getChatComunication: state => state.chatComunication,
    getGroupsLevels: state => state.groupsLevels,
    getOrderStates: state => state.medicalOrderStates
  },
  actions: {
    async fetchConstantsUI({ commit }) {
      const constants = await Utils.getUIConfig();
      commit(STORE_CONSTANTS.SET_CONSTANTS_UI, constants);
    }
  },
  modules: {}
});
